import { Button, Modal } from 'react-bootstrap'
import React from 'react'

const Dialog = ({ title, body, show, handleClose }) => {

    return <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
            <p>{body}</p>
        </Modal.Body>

        <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>Close</Button>
        </Modal.Footer>
        </Modal>
}

export default Dialog


